import {customElement} from 'lit/decorators.js';
import {of} from 'rxjs';
import {ActivityOption} from './activity-option';
import {FilterView} from './filter-view';
import {Filter} from './interfaces/filterable';
import {ri} from './runner-idle';
import {UnlockableLitElement} from './unlockable-lit-element';

// Unlockables display

@customElement('ri-unlockables')
export class Unlockables extends FilterView {
  // #region Properties (12)

  public static override styles = [...FilterView.styles];

  // public override filterablesBeforeShowFilter = 5;
  public override filters = new Set([
    // 'landmark',
    // 'panel',
    'activity',
    // 'activity-option',
    'stat',
    'resource',
    'spell',
    'unlocked',
  ]);
  public override helpContent = `<div>
    The <b>Unlockables</b> panel shows you all the things you can unlock in the game,
    <br>along with the requirements to unlock them.
    <br>
    <br>Square items are unlocked, while rounded ones are still locked.
    <br>Hover over an item to see its details.
    <br>
    <br>You can filter the list to show only some kinds of items,
    <br>only locked items, and more.
  </div>`;
  public override id = 'unlockables';
  public override name = 'Goals';
  public override possibleFilters: Set<Filter> = new Set([
    {name: 'landmark', displayName: 'Landmark'},
    {name: 'panel', displayName: 'Panel'},
    {name: 'activity-option', displayName: 'Options'},
    {name: 'activity', displayName: 'Activity'},
    {name: 'stat', displayName: 'Stat'},
    {name: 'resource', displayName: 'Resource'},
    {name: 'spell', displayName: 'Spell'},
    {
      name: 'hidden',
      displayName: 'Hidden',
      condition: (item) =>
        !(item.filterable.unlocked || item.filterable.visible) ?? false,
    },
    {
      name: 'unlocked',
      displayName: 'Locked Only',
      condition: (item) => {
        if (item.filterable instanceof ActivityOption) {
          if (!item.filterable.activity.unlocked) {
            return false;
          }
        }
        return (!item.filterable.unlocked || item.filterable.new) ?? false;
      },
      only: true,
    },
    {
      name: 'undiscovered',
      displayName: 'Undiscovered Only',
      condition: (item) => item.filterable.secret ?? false,
      only: true,
    },
  ]);
  public override replace = true;
  public override replacementEntryTag = 'ri-unlockables-entry';
  public override subtitle = 'What will you work on next?';
  constructor() {
    super();
    this.filterables$ = of(Object.values(ri.unlockables));
    this.unlock$ = ri.landmarks.guidebook.visited$;
  }

  // #endregion Properties (12)

  // #region Public Methods (1)

  public override compare(
    a: UnlockableLitElement & {filterable: UnlockableLitElement},
    b: UnlockableLitElement & {filterable: UnlockableLitElement}
  ) {
    const _a = a.filterable;
    const _b = b.filterable;
    if (_a.unlocked && !_b.unlocked) return -1;
    if (!_a.unlocked && _b.unlocked) return 1;
    // if (_a.new && !_b.new) return -1;
    // if (!_a.new && _b.new) return 1;
    if (_a.secret && !_b.secret) return 1;
    if (!_a.secret && _b.secret) return -1;
    if (!_a.visible && _b.visible) return 1;
    if (_a.visible && !_b.visible) return -1;
    if (_a.conditionString < _b.conditionString) return -1;
    if (_a.conditionString > _b.conditionString) return 1;
    return a.compareDocumentPosition(b);
  }

  // #endregion Public Methods (1)
}
